import Swiper, { Keyboard } from 'swiper'
import 'swiper/swiper-bundle.min.css'

Swiper.use([Keyboard])

new Swiper('.steps-slider', {
  loop: false,
  spaceBetween: 24,
  
  slideToClickedSlide: true,

  keyboard: true,

  slidesPerView: 1.35,
  slidesOffsetBefore: 18,
  
  breakpoints: {
    991: {
      centeredSlides: true,
      slidesPerView: 2.8,
      slidesOffsetBefore: -200,
      slidesOffsetAfter: 24,
    },
  },
})


// WEBPACK FOOTER //
// ./scripts/components/sliders/steps.js